import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NmInput } from '../input/input';

declare let $: any;

export interface NmMaskedInputOptions {
	placeholder?: string,
	translation?: { 
		[key:string]: {
			pattern: RegExp,
			optional?: boolean,
			recursive?: boolean,
		}
	}
}

// ref: https://igorescobar.github.io/jQuery-Mask-Plugin/
@Component({
	selector: 'nm-masked-input',
	templateUrl: './masked-input.html',
	providers: [
		{
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: forwardRef(() => NmMaskedInput),
	    multi: true,
	  }
  ]
})
export class NmMaskedInput extends NmInput {
	@Input() mask: string;
	@Input() options: NmMaskedInputOptions = {};

	private id: string;

	public ngAfterViewInit(): void {
		super.ngAfterViewInit();

		// default translation pattern
		this.options = Object.assign(this.options, {
			translation: {
				'Z': { pattern: /[0-9]/, optional: true },
				'r': { pattern: /[\s-]/, optional: true }
			}
		});

		let elem = this.elementRef.nativeElement.querySelector('input');
		$(elem).mask(this.mask, this.options);

	}

}


// WEBPACK FOOTER //
// ./src/widgets/masked-input/masked-input.ts